import { getReq, postReq } from './axios';
import { allDepositsParams } from './models';
var BASE_URL = "".concat(apiUrl, "/franchisee-deposit");
export var getAllFranchiseeDeposits = function getAllFranchiseeDeposits(params) {
  return getReq(BASE_URL, {
    params: allDepositsParams(params)
  });
};
export var getAllFranchiseeDepositsBalance = function getAllFranchiseeDepositsBalance(params) {
  return getReq("".concat(BASE_URL, "/get-balance"), {
    params: allDepositsParams(params)
  });
};
export var postFranchiseeDeposits = function postFranchiseeDeposits(value) {
  return postReq(BASE_URL, value);
};